import { Task } from 'src/app/services/dtos/task';
import { TaskSearchForm } from '../../services/dtos/taskSearchForm';
import { ProcessType } from 'src/app/services/enums/processType.enum';


export class FetchTasksBasicInfo {
  public static readonly type = '[Tasks] Fetch Tasks Basic Infos';
  public constructor(public from: string, public to: string, public filters: TaskSearchForm) {}
}

export class FetchTask {
  public static readonly type = '[Tasks] Fetch Task';
  public constructor(public id: string) {}
}

export class FetchTaskContent {
  public static readonly type = '[Tasks] Fetch Task Content';
  public constructor(public id: string, public processType: ProcessType) {}
}

export class ScheduleTaskForReRun {
  public static readonly type = '[Tasks] Schedule task for re-run';
  public constructor(public payload: Task) {}
}

export class SetCurrentTaskId {
  public static readonly type = '[Tasks] Set Current Task Id';
  public constructor(public id: string) {}
}

export class ClearCurrentTaskId {
  public static readonly type = '[Tasks] Clear Current Task Id';
}

export class DeleteTask {
  public static readonly type = '[Tasks] Delete Task';
  public constructor(public id: string) {}
}
